import { render, staticRenderFns } from "./Opcoes.vue?vue&type=template&id=14683bb5&scoped=true"
import script from "./Opcoes.vue?vue&type=script&lang=js"
export * from "./Opcoes.vue?vue&type=script&lang=js"
import style0 from "./Opcoes.vue?vue&type=style&index=0&id=14683bb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14683bb5",
  null
  
)

export default component.exports